/*
 * Do not remove or alter the notices in this preamble.
 * This software code regards iO Custom Software.
 * Copyright © 2026 iO The Netherlands B.V. and/or its affiliates.
 * www.iodigital.com All rights reserved. License grant and user rights and obligations
 * according to applicable license agreement. Please contact legal@iodigital.com for
 * questions regarding license and user rights.
 */

import { devtools } from 'zustand/middleware';
import { createStore } from 'zustand/vanilla';

import { GlobalComponentPropertiesTypes } from '@/types';
import { globalStorePropertiesStore } from './creators/creator.global-store-properties';
import {
  ValidationState,
  validationStore,
} from './creators/creator.validation';

export type ConfiguratorState = GlobalComponentPropertiesTypes &
  ValidationState & {};

export const configuratorStore = createStore<ConfiguratorState>()(
  devtools((set, get, api) => ({
    ...globalStorePropertiesStore(set, get, api),
    ...validationStore(set, get, api),
  })),
);
